import { AxiosGet } from '../useApi';

const route = 'security-profiles';

export function GetSecurityProfiles(params) {
    return AxiosGet(route, params);
}

export function GetSecurityProfileById(params) {
    return AxiosGet(`${route}/by-id`, params);
}
